import React, { useState, useMemo } from 'react'
import { getUserInfoSync } from '../../config/api'
import apiClient from '../../config/api'
import { API_ENDPOINTS } from '../../config/api'
import Swal from 'sweetalert2'
import CreateLayby from './Layby/CreateLayby'
import LaybyList from './Layby/LaybyList'
import LaybyDetail from './Layby/LaybyDetail'

const brandColors = {
  primary: '#1338b5',
  mid: '#1f4dc7',
  bright: '#5c8ef0',
}

// Helper function to get branch_id from userInfo
const getBranchId = (userInfo) => {
  if (!userInfo) {
    return null
  }

  if (typeof userInfo.branch === 'number') {
    return userInfo.branch
  }

  if (typeof userInfo.branch === 'object' && userInfo.branch !== null) {
    if (typeof userInfo.branch.id === 'number') {
      return userInfo.branch.id
    }
  }

  return (
    userInfo.branch_id ||
    userInfo.assigned_branch_id ||
    userInfo.branchId ||
    null
  )
}

const Layby = () => {
  const [activeView, setActiveView] = useState('list') // 'list', 'create', 'detail'
  const [selectedLayby, setSelectedLayby] = useState(null)
  const userInfo = useMemo(() => getUserInfoSync(), [])

  const handleViewChange = (view, layby = null) => {
    setActiveView(view)
    setSelectedLayby(layby)
  }

  return (
    <>
      <div className="pagetitle">
        <h1>Layby Management</h1>
      </div>
      <section className="section">
        <div className="card shadow-sm border-0">
          <div className="card-body">
            {/* Navigation Tabs */}
            <ul className="nav nav-tabs mb-4" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeView === 'list' ? 'active' : ''}`}
                  onClick={() => handleViewChange('list')}
                  type="button"
                  style={{
                    color: activeView === 'list' ? brandColors.primary : '#6c757d',
                    fontWeight: activeView === 'list' ? 600 : 400,
                  }}
                >
                  <i className="bi bi-list-ul me-2" />
                  All Laybys
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeView === 'create' ? 'active' : ''}`}
                  onClick={() => handleViewChange('create')}
                  type="button"
                  style={{
                    color: activeView === 'create' ? brandColors.primary : '#6c757d',
                    fontWeight: activeView === 'create' ? 600 : 400,
                  }}
                >
                  <i className="bi bi-plus-circle me-2" />
                  Create Layby
                </button>
              </li>
            </ul>

            {/* View Content */}
            {activeView === 'list' && (
              <LaybyList
                userInfo={userInfo}
                onViewDetail={(layby) => handleViewChange('detail', layby)}
              />
            )}
            {activeView === 'create' && (
              <CreateLayby
                userInfo={userInfo}
                branchId={getBranchId(userInfo)}
                onSuccess={() => {
                  Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Layby created successfully',
                    confirmButtonColor: brandColors.primary,
                  })
                  handleViewChange('list')
                }}
              />
            )}
            {activeView === 'detail' && selectedLayby && (
              <LaybyDetail
                layby={selectedLayby}
                userInfo={userInfo}
                branchId={getBranchId(userInfo)}
                onBack={() => handleViewChange('list')}
                onPaymentSuccess={() => {
                  // Refresh layby details after payment
                  apiClient
                    .get(`${API_ENDPOINTS.LAYBY}${selectedLayby.id}/`)
                    .then((response) => {
                      setSelectedLayby(response.data)
                      Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: 'Payment recorded successfully',
                        confirmButtonColor: brandColors.primary,
                      })
                    })
                    .catch((error) => {
                      console.error('Error refreshing layby:', error)
                    })
                }}
              />
            )}
          </div>
        </div>
      </section>
    </>
  )
}

export default Layby
